// UsersMfaAndLocation only. Shared table methods are in tableMixin.js.
export default {
    name: "UsersMfaAndLocation",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs = this.getDefaultFormInputs();
            this.$clearValidationStates("#recordForm");
        },
        handleFetchRolesSuccess(response) {
            this.rolesOptions = response.data.results;
        },
    },
};